import request from '@/utils/request'



// 获取充值信息 
export function getWithDrawalList(pageNum) {
    return request({
    url: '/api/withdrawal/list',
    method: 'get',
    params: {
      pageNum
    }
  })
}

// 获取账户信息
export function getSupperWithDrawalList(pageNum){
  return request({
    url: '/api/withdrawal/supper/list',
    method: 'get',
     params: {
      pageNum
    }
  })
}

// 提交充值记录
export function addWithDrawal(data) {
  return request({
    url: '/api/withdrawal/add',
    method: 'post',
    data: data
  })
}

// 提交充值记录
export function examine(data,id) {
  return request({
    url: '/api/withdrawal/examine/'+id,
    method: 'post',
    data: data
  })
}

// 获取账户信息
export function getConfig(key){
  return request({
    url: '/api/config/key',
    method: 'get',
     params: {
      key
    }
  })
}
